export function listToLower(list: string[]) {
    return list.map((element) => String.prototype.toLowerCase.call(element));
}
